export const APP_FILE_ENV_CONFIG_LIST = "/settings/env-config";
